export function getColor(value) {
  if (value >= 10) {
    return 'green';
  }
  if (value <= 0) {
    return 'red';
  }
  return 'yellow';
}
